/** Özel dosyalar yalnızca BARAN (Id=2) kullanıcısına açıktır. */
export function canAccessOzelDosyalar(user) {
  if (!user) return false;
  const userId = user.Id ?? user.id;
  if (userId === 2) return true;
  const username = String(user.Username ?? user.username ?? '').toUpperCase();
  return username === 'BARAN';
}

export function isOzelCaseFile(file) {
  if (!file) return false;
  return !!(file.IsOzel ?? file.isOzel);
}

export function isOzelJob(job) {
  if (!job) return false;
  return !!(job.CaseFileIsOzel ?? job.caseFileIsOzel);
}
